import { Pagination, Skeleton } from 'antd';
import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import Footer from '../../components/Footer/Footer';
import Header from '../../components/Header/Header';
import ProductCard from '../../components/ProductCard/ProductCard';
import ResNavBar from '../../components/ResNavBar/ResNavBar';
import { fetchOffers, fetchOffersType } from '../../network/home.network';
import localization from '../../Localization/Localization.json'
import "./Offers.scss"
class Offers extends Component {

    state = {
        offerList : [],
        offerTypes : null, 
        loading : true,
        isOfferSection : false
    }

    componentDidMount() { 
        const {match} = this.props;
        console.log(match); 
        if(match?.params?.id){
            let body = new FormData();
            body.append("offer_type_id", match.params.id); 
            fetchOffersType(body, (res) => {
                console.log(res.data.data);
                this.setState({ 
                    offerList : res.data.data.products, 
                    pagination : res.data.data.pagination, 
                    loading : false})
            }, (error) => {
                this.setState({loading : false})
            })
        }else{
            fetchOffers(false, (res) => {
                this.setState({ offerList : res.data.data.products, pagination : res.data.data.pagination,  offerTypes : res.data.data.offerTypes, loading : false})
            }, (error) => {
                this.setState({loading : false})
            })
        }
    }

    onChangePagination  = (page) => {
        const {match} = this.props;
        this.setState({loading : true})
        if(match?.params?.id){
            let body = new FormData();
            body.append("offer_type_id", match.params.id); 
            if(this.state.pagination?.totalPages > 1 && page){ 
                body.append("page", page); 
              }
            fetchOffersType(body, (res) => {
                console.log(res.data.data);
                this.setState({ 
                    offerList : res.data.data.products, 
                    pagination : res.data.data.pagination, 
                    loading : false})
            }, (error) => {
                this.setState({loading : false})
            })
        }else{
            let params = ""; 
            if(this.state.pagination?.totalPages > 1 && page){ 
                params += `?page=${page}`; 
              }
            fetchOffers(params, (res) => {
                this.setState({ offerList : res.data.data.products, pagination : res.data.data.pagination,  offerTypes : res.data.data.offerTypes, loading : false})
            }, (error) => {
                this.setState({loading : false})
            })
        }
    }
    
    render() {
        const { currentLang, match } = this.props;
        const { offerList, loading, pagination, offerTypes } = this.state;
        return (
            <div className="offer-page-wrapper">
                <Header />
                <div className="offer-hero">
                    <h1>{localization.Offers[currentLang]}</h1> 
                </div>
                <div className="container">
                    <div className="offer-content"> 
                        <div className="offer-card-wrapper">
                        {offerTypes?.map(offer => 
                            <Link key={offer.id} to={`/offers/${offer.id}/${offer.name}`} className="offer-card">
                                <h4 className="offer-subtitle">{offer.name}</h4> 
                                <h3 className="free-title">{localization.FREE[currentLang]}</h3>
                            </Link>
                        )}
                        </div>  
                        {match.params.name ? 
                            <h4 className="section-title">{match.params.name}</h4> 
                            : <h4 className="section-title">{localization.Discounts[currentLang]}</h4>
                        }
                        <div className="offer-grid-wrapper">
                            {!loading
                                ? offerList.map((card) => (  
                                    <ProductCard offerID={match.params.id ? match.params.id : null} discount card={card} />
                                ))
                                : [0, 0, 0, 0, 0, 0, 0, 0].map((skl, idx) => (
                                    <Skeleton key={idx} avatar active paragraph={{ rows: 4 }} />
                                ))}
                        </div>
                    </div>
                    {pagination && pagination?.totalPages > 1 && 
                <div className="pagination-wrapper">    
                  <Pagination responsive 
                  onChange={this.onChangePagination}
                  current={pagination?.current} pageSize={pagination?.size} total={pagination?.total} /> 
                </div>
                }
                </div>
                <Footer />
                <ResNavBar /> 
            </div>
        )
    }
}

const offersWithRouter = withRouter(Offers); 
const mapStateToProps = (state) => ({
  productsList: state.products.productsList.slice(200, 230),
  currentLang : state.user.currentLang,
});
export default connect(mapStateToProps)(offersWithRouter);